import React, { useState, useEffect } from "react";
import { Navigate } from "react-router";
import { Line } from "react-chartjs-2";
import { Chart } from "chart.js/auto";
import { Box, Button, Grid, Paper, Typography } from "@mui/material";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import BusinessIcon from "@mui/icons-material/Business";
import CategoryIcon from "@mui/icons-material/Category";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import PersonIcon from "@mui/icons-material/Person";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import ChartDataLabels from "chartjs-plugin-datalabels";
import ChartPieChartOutlabels from "@energiency/chartjs-plugin-piechart-outlabels";
import iconforfvlogo from "../icons/fvlogo.png";
import favicon from "../icons/fvlogo.ico";
import { Helmet } from "react-helmet";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import ListItemText from "@mui/material/ListItemText";
import Select from "@mui/material/Select";
import Checkbox from "@mui/material/Checkbox";
import FilterListIcon from "@mui/icons-material/FilterList";
import CloseIcon from "@mui/icons-material/Close";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import moment from "moment";
import { DATE_FORMATS } from "../utils/constants";

Chart.register(ChartPieChartOutlabels);

function Dashh() {
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  const formatter = new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
  });

  // Data table for investor
  const [originalData, setoriginalData] = useState([]); // Original data loaded for the logged on investor
  const [v1inv, setv1inv] = useState([]); // Copy of the original data on which the data is loaded

  // Measures calculated out of the v1inv data
  const [total_inv, settotal_inv] = useState([]);
  const [current_value, setcurrent_value] = useState([]);
  const [pnl, setpnl] = useState([]);
  const [startups_covered, setstartups_covered] = useState([]);
  const [domains_covered, setdomains_covered] = useState([]);
  const [latest_date, setlatest_date] = useState([]);
  const [wealth_manager, setwealth_manager] = useState([]);
  const [iname, setiname] = useState([]);
  const [tdata, settdata] = useState([]);

  // for filter selection menu
  const [open, setOpen] = useState(false);
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = (event, reason) => {
    if (reason !== "backdropClick") {
      setOpen(false);
    }
  };

  const handleClearFilters = () => {
    setcfundsName([]);
    setcstartupName([]);
    setcdomainName([]);
    // Reset the data back to original data when clearing filters
    setv1inv(originalData);
  };
  //_____________________________________

  // Logout link function
  const handleLinkClickfv = async () => {
    try {
      localStorage.removeItem("finvolveInvestorData");
      Navigate("/investor-login");
    } catch (error) {
      console.error(error);
    }
  };

  // Handle Apply For Accreditation button click
  const handleAccreditationClick = (e) => {
    e.preventDefault();

    console.log("Apply For Accreditation clicked");

    try {
      const finvolveInvestorData = JSON.parse(
        localStorage.getItem("finvolveInvestorData"),
      );

      console.log(
        "Investor data from localStorage:",
        finvolveInvestorData ? "Found" : "Not found",
      );

      if (
        finvolveInvestorData &&
        finvolveInvestorData.jwt &&
        finvolveInvestorData.email
      ) {
        // Construct URL with JWT and email as parameters after /login
        // Use environment variable for base URL or default to production
        const baseUrl =
          process.env.REACT_APP_FORM_URL ||
          "https://finvolve-ndml-form.vercel.app";
        const params = new URLSearchParams({
          jwt: finvolveInvestorData.jwt,
          email: finvolveInvestorData.email,
        });

        const url = `${baseUrl}/login?${params.toString()}`;

        console.log(
          "Opening URL:",
          url.substring(0, 50) + "...[JWT_AND_EMAIL]",
        );
        console.log("JWT present:", !!finvolveInvestorData.jwt);
        console.log("Email:", finvolveInvestorData.email);

        window.open(url, "_blank", "noopener,noreferrer");
      } else {
        console.warn(
          "Missing investor data, JWT, or email. Opening form without parameters.",
        );
        // Fallback if no data is found
        const baseUrl =
          process.env.REACT_APP_FORM_URL ||
          "https://finvolve-ndml-form.vercel.app";
        window.open(`${baseUrl}/login`, "_blank", "noopener,noreferrer");
      }
    } catch (error) {
      console.error("Error opening accreditation form:", error);
      // Fallback to base URL
      const baseUrl =
        process.env.REACT_APP_FORM_URL ||
        "https://finvolve-ndml-form.vercel.app";
      window.open(`${baseUrl}/login`, "_blank", "noopener,noreferrer");
    }
  };

  useEffect(() => {
    async function fetchData() {
      const finvolveInvestorData = JSON.parse(
        localStorage.getItem("finvolveInvestorData"),
      );
      // one set of data for all measures and visuals for investors
      const responsev1inv = await fetch(
        `${API_BASE_URL}/api/investor/investments/${finvolveInvestorData?.email}`,
        {
          headers: {
            Authorization: `Bearer ${finvolveInvestorData?.jwt}`,
          },
        },
      );
      const { data } = await responsev1inv.json();

      const v1inv = data?.investments;
      setv1inv(v1inv);
      setoriginalData(v1inv);

      // Calculations for the Measures below

      // wealth_manager
      const wealthmanagers = [
        ...new Set(v1inv.map((item) => item.wealthmanager)),
      ];
      setwealth_manager(wealthmanagers);

      // Total Investments
      const sumIvalL = v1inv.reduce((accumulator, currentValue) => {
        return accumulator + parseFloat(currentValue.ival_l);
      }, 0);
      settotal_inv(sumIvalL);

      // Current Value Total
      const sumCvalL = v1inv.reduce((accumulator, currentValue) => {
        return accumulator + parseFloat(currentValue.Cval_l);
      }, 0);
      setcurrent_value(sumCvalL);

      // Unrealized P&L Value Total
      const pnl = v1inv.reduce((accumulator, currentValue) => {
        return accumulator + parseFloat(currentValue.pnl);
      }, 0);
      setpnl(pnl);

      // Startups Covered
      const distinctSUCount = [
        ...new Set(v1inv.map((investment) => investment.startupname)),
      ].length;
      setstartups_covered(distinctSUCount);

      // Domains Covered
      const distinctdomainCount = [
        ...new Set(v1inv.map((investment) => investment.SU_Domain)),
      ].length;
      setdomains_covered(distinctdomainCount);

      // Use reduce to find the latest date
      const latestDate = v1inv.reduce(
        (latest, item) => {
          const itemDate = moment(item.issuedate2, DATE_FORMATS, true); // strict parsing

          // Only consider valid dates
          if (itemDate.isValid() && itemDate.isAfter(latest)) {
            return itemDate;
          }
          return latest;
        },
        moment("01-01-2015", "DD-MM-YYYY"),
      );
      setlatest_date(latestDate?.format("DD MMM YYYY"));

      // Investor Name
      const iname = [...new Set(v1inv.map((item) => item.investor))];
      setiname(iname);

      //reverse chronologically arranged dates for the table data
      settdata(
        [...v1inv].sort((a, b) => {
          const dateA = moment(a.issuedate2, DATE_FORMATS, true);
          const dateB = moment(b.issuedate2, DATE_FORMATS, true);

          // Handle invalid dates by putting them at the end
          if (!dateA.isValid() && !dateB.isValid()) return 0;
          if (!dateA.isValid()) return 1;
          if (!dateB.isValid()) return -1;

          return dateB - dateA;
        }),
      );
    }
    fetchData();
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    //  console.log("This is from inside useeffect " + JSON.stringify(v1inv,null,2))
    // Calculations for the Measures below

    // Total Investments
    const sumIvalL = v1inv.reduce((accumulator, currentValue) => {
      return accumulator + parseFloat(currentValue.ival_l);
    }, 0);
    settotal_inv(sumIvalL);
    // console.log("1. Total Investments is "+ (total_inv) + ".");

    // Current Value Total
    const sumCvalL = v1inv.reduce((accumulator, currentValue) => {
      return accumulator + parseFloat(currentValue.Cval_l);
    }, 0);
    setcurrent_value(sumCvalL);
    // console.log("2. Total current value is "+ (current_value) + ".");

    // Unrealized P&L Value Total
    const pnl = v1inv.reduce((accumulator, currentValue) => {
      return accumulator + parseFloat(currentValue.pnl);
    }, 0);
    setpnl(pnl);
    // console.log("3. Total pnl is "+ (pnl) + ".");

    // console.log("4. Funds Invested "+ (funds_invested) + ".");

    // Startups Covered
    const distinctSUCount = [
      ...new Set(v1inv.map((investment) => investment.startupname)),
    ].length;
    setstartups_covered(distinctSUCount);
    // console.log("5. Startups Covered "+ (funds_invested) + ".");

    // Domains Covered
    const distinctdomainCount = [
      ...new Set(v1inv.map((investment) => investment.SU_Domain)),
    ].length;
    setdomains_covered(distinctdomainCount);

    // Use reduce to find the latest date
    const latestDate = v1inv.reduce(
      (latest, item) => {
        const itemDate = moment(item.issuedate2, DATE_FORMATS, true); // strict parsing

        // Only consider valid dates
        if (itemDate.isValid() && itemDate.isAfter(latest)) {
          return itemDate;
        }
        return latest;
      },
      moment("01-01-2015", "DD-MM-YYYY"),
    );
    setlatest_date(latestDate?.format("DD MMM YYYY"));

    //reverse chronologically arranged dates for the table data
    settdata(
      [...v1inv].sort((a, b) => {
        const dateA = moment(a.issuedate2, DATE_FORMATS, true);
        const dateB = moment(b.issuedate2, DATE_FORMATS, true);

        // Handle invalid dates by putting them at the end
        if (!dateA.isValid() && !dateB.isValid()) return 0;
        if (!dateA.isValid()) return 1;
        if (!dateB.isValid()) return -1;

        return dateB - dateA;
      }),
    );
  }, [v1inv]);

  // below for dropdowns

  const ITEM_HEIGHT = 158;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        fontSize: 12,
        width: 250,
      },
    },
  };

  // checkbox for funds
  const checks_funds = [...new Set(originalData.map((item) => item.fundname))];
  const [cfundsName, setcfundsName] = useState([]);
  const handleChangecfunds = (event) => {
    const { value } = event.target;
    const selectedFunds = Array.isArray(value) ? value : [value];
    setcfundsName(selectedFunds);
  };

  // checkbox for funds
  const checks_startup = [
    ...new Set(originalData.map((item) => item.startupname)),
  ];
  const [cstartupName, setcstartupName] = useState([]);
  const handleChangecstartup = (event) => {
    const { value } = event.target;
    const selectedStartups = Array.isArray(value) ? value : [value];
    setcstartupName(selectedStartups);
  };

  // checkbox for Domain
  const checks_domain = [
    ...new Set(originalData.map((item) => item.SU_Domain)),
  ];
  const [cdomainName, setcdomainName] = useState([]);
  const handleChangecdomain = (event) => {
    const { value } = event.target;
    const selectedDomains =
      typeof value === "string" ? value.split(",") : value;
    setcdomainName(selectedDomains);
  };

  // Filter effect - combines all filters together
  useEffect(() => {
    const filteredData = originalData.filter(
      (item) =>
        (cfundsName.length === 0 || cfundsName.includes(item.fundname)) &&
        (cstartupName.length === 0 ||
          cstartupName.includes(item.startupname)) &&
        (cdomainName.length === 0 || cdomainName.includes(item.SU_Domain)),
    );
    setv1inv(filteredData);
  }, [cfundsName, cstartupName, cdomainName, originalData]);

  // above for dropdowns

  //____________________________________________________________________________________________________
  // Data and options for Startups Composition waterfall chart

  // prepping data for wf step1 grouping startups,
  const startupsandcvsum = {};
  for (let i = 0; i < v1inv.length; i++) {
    const startup = v1inv[i];
    const startupName = startup.startupname;
    const Cval_l = parseFloat(startup.Cval_l);

    if (startupsandcvsum[startupName]) {
      startupsandcvsum[startupName].Cval_l += Cval_l;
    } else {
      startupsandcvsum[startupName] = {
        startupname: startupName,
        Cval_l: Cval_l,
      };
    }
  }
  const startupsandcvsumfinal = Object.values(startupsandcvsum);
  // console.log(JSON.stringify(startupsandcvsum, null, 2));
  let startupsData = {};
  startupsandcvsumfinal.sort(
    (a, b) => parseFloat(b.Cval_l) - parseFloat(a.Cval_l),
  );
  let total = 0;
  for (let i = 0; i < startupsandcvsumfinal.length; i++) {
    const startup = startupsandcvsumfinal[i];
    const currentValue = [total, total + parseFloat(startup.Cval_l)];
    startupsData[startup.startupname] = currentValue.join(",");
    total += parseFloat(startup.Cval_l);
  }
  startupsData["Total"] = `0,${total}`;

  const labels = Object.keys(startupsData);
  const colors = [];
  for (let i = 0; i < labels.length; i++) {
    if (labels[i] !== "Total") {
      colors.push("#2E927C"); // color for startups
    } else {
      colors.push("#3281B7"); // color for total
    }
  }

  const startups_composition_data = {
    labels: startupsandcvsumfinal.map((startup) => startup.startupname),
    datasets: [
      {
        label: "Current Value",
        data: startupsandcvsumfinal.map((startup) => startup.Cval_l),
        borderColor: "#10B981",
        borderWidth: 3,
        fill: false,
        tension: 0.4,
        pointBackgroundColor: "#10B981",
        pointBorderColor: "#FFFFFF",
        pointBorderWidth: 2,
        pointRadius: 6,
        pointHoverRadius: 8,
        pointHoverBackgroundColor: "#059669",
        pointHoverBorderColor: "#FFFFFF",
        pointHoverBorderWidth: 3,
      },
    ],
  };

  // options for the chart
  const startups_composition_options = {
    responsive: true,
    maintainAspectRatio: false,
    animation: {
      duration: 2000,
      easing: "easeInOutQuart",
      delay: (context) => context.dataIndex * 200,
    },
    interaction: {
      intersect: false,
      mode: "index",
    },
    labels: {
      display: false,
    },
    scales: {
      x: {
        title: {
          display: true,
          text: "Startup Name",
          color: "#374151",
          font: {
            family: "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI'",
            size: 13,
            weight: 600,
          },
          padding: {
            top: 15,
            bottom: 10,
          },
        },
        grid: {
          display: false,
        },
        ticks: {
          color: "#6B7280",
          font: {
            family: "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI'",
            size: 11,
            weight: 500,
          },
          maxRotation: 45,
          minRotation: 45,
        },
      },
      y: {
        beginAtZero: true,
        title: {
          display: true,
          text: "Current Value",
          color: "#374151",
          font: {
            family: "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI'",
            size: 13,
            weight: 600,
          },
          padding: {
            top: 10,
            bottom: 15,
          },
        },
        grid: {
          color: "rgba(107, 114, 128, 0.1)",
          drawBorder: false,
          lineWidth: 1,
        },
        ticks: {
          color: "#6B7280",
          font: {
            family: "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI'",
            size: 11,
            weight: 500,
          },
          callback: function (value, index, ticks) {
            return `₹${value}L`;
          },
        },
        border: {
          display: false,
        },
      },
    },
    layout: {
      padding: {
        top: 30,
        bottom: 30,
        left: 20,
        right: 20,
      },
    },
    plugins: {
      tooltip: {
        enabled: true,
        backgroundColor: "rgba(255, 255, 255, 0.95)",
        bodyColor: "#1F2937",
        titleColor: "#374151",
        borderColor: "rgba(226, 232, 240, 0.8)",
        borderWidth: 1,
        cornerRadius: 12,
        displayColors: true,
        titleFont: {
          family: "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI'",
          size: 13,
          weight: 600,
        },
        bodyFont: {
          family: "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI'",
          size: 12,
          weight: 500,
        },
        padding: 16,
        boxShadow:
          "0 10px 25px rgba(0, 0, 0, 0.1), 0 4px 10px rgba(0, 0, 0, 0.05)",
        callbacks: {
          label: function (context) {
            var value = context.dataset.data[context.dataIndex];
            var result = Number(value).toFixed(2);
            return `Current Value: ₹${result}L`;
          },
        },
      },
      legend: {
        display: false,
        position: "right",
        align: "right",
      },
      datalabels: {
        display: false,
      },
    },
  };

  //_______________________________________________________________

  const fundsData = {};
  v1inv.forEach((item) => {
    if (!fundsData[item.fundname]) {
      fundsData[item.fundname] = 0;
    }
    fundsData[item.fundname] += parseFloat(item.Cval_l);
  });

  const domainDataa = {};
  v1inv.forEach((item) => {
    if (!domainDataa[item.SU_Domain]) {
      domainDataa[item.SU_Domain] = 0;
    }
    domainDataa[item.SU_Domain] += parseFloat(item.Cval_l);
  });
  ///sorting the above data in descending order
  const domainData = Object.entries(domainDataa)
    .sort((a, b) => b[1] - a[1])
    .reduce((acc, [key, value]) => {
      acc[key] = value;
      return acc;
    }, {});

  // data and options for funds composition (commented out - not currently used)
  // const funds_composition_data = {
  //   labels: Object.keys(fundsData),
  //   datasets: [
  //     {
  //       data: Object.values(fundsData).map((value) => value),
  //       backgroundColor: [
  //         "#3281B7",
  //         "#2E927C",
  //         "#EF9921",
  //         "#7EA8C2",
  //         "#73A59C",
  //         "#F7CC8B",
  //         "#E87934",
  //         "#666666",
  //         "#3599B8",
  //         "#DFBFBF",
  //         "#4AC5BB",
  //         "#5F6B6D",
  //         "#F4D25A",
  //         "#7F898A",
  //         "#A4DDEE",
  //         "#FDAB89",
  //       ],
  //     },
  //   ],
  // };
  // const funds_composition_options = {
  //   //circumference: 0,
  //   // radius: "100%",
  //   // cutout :"60%",
  //   radius: "70%",
  //   layout: {
  //     padding: 25,
  //   },
  //   // zoomOutPercentage: "60",
  //   plugins: {
  //     /*
  //     datalabels: {
  //     align: 'center',
  //     anchor: 'end',
  //     backgroundColor: 'white',
  //     borderRadius:'5',
  //     display: false,
  //     formatter:(value,context) => {
  //       return context.chart.data.labels[context.dataIndex] + ': '+ `${value}%`;
  //     }
  //     },*/
  //     outlabels: {
  //       display: true,
  //       // text: "%l \n₹%v.2L (%p.2) ",
  //       // text: "%l ₹%v.2L",
  //       text: "₹%v.2L (%p.2)",
  //       color: "black",
  //       // lineColor: "#4C4A48",
  //       lineWidth: "1",
  //       stretch: 2,
  //       font: {
  //         resizable: false,
  //         family: "Segoe UI",
  //         size: "12",
  //       },
  //       // backgroundColor: false,
  //       // formatter: function (value, context) {
  //       //   var percentage = context.dataset.percentages[context.dataIndex];
  //       //   if (percentage > 5) {
  //       //     return '';
  //       //   } else {
  //       //     return value;
  //       //   }
  //       // }
  //     },
  //
  //     tooltip: {
  //       enabled: true,
  //       backgroundColor: "white",
  //       bodyColor: "Black",
  //       titleColor: "Black",
  //       callbacks: {
  //         label: function (context) {
  //           var label = context.dataset.label || "";
  //           if (label) {
  //             label += ": ";
  //           }
  //           var value = context.dataset.data[context.dataIndex];
  //           var total = context.dataset.data.reduce((acc, val) => acc + val, 0);
  //           var percentage = ((value / total) * 100).toFixed(2);
  //           var result = value.toFixed(2);
  //           label += `Current Value: ₹${result}L (${percentage}% of Total)`;
  //           return label;
  //         },
  //       },
  //     },
  //
  //     title: {
  //       display: false,
  //       align: "start",
  //       text: "Current Valuation of Holdings - Startups",
  //       color: "Black",
  //       fontFamily: "Arial",
  //       fontSize: "18",
  //       padding: { bottom: 20 },
  //     },
  //     legend: {
  //       display: true,
  //       position: "top",
  //       align: "center",
  //     },
  //   },
  //   //customCanvasBackgroundColor: {
  //   //  color: 'white',
  //   //},
  //   responsive: true,
  //   maintainAspectRatio: false,
  //   //  plugins: [
  //   //    ChartPieChartOutlabels
  //   //  ]
  // };

  //___________________________________________________________

  // data and options for domain composition horizontal chart

  const domain_composition_data = {
    labels: Object.keys(domainData),
    datasets: [
      {
        label: "Current Value",
        data: Object.values(domainData).map((value) => value),
        borderColor: "#3B82F6",
        borderWidth: 3,
        fill: false,
        tension: 0.4,
        pointBackgroundColor: "#3B82F6",
        pointBorderColor: "#FFFFFF",
        pointBorderWidth: 2,
        pointRadius: 6,
        pointHoverRadius: 8,
        pointHoverBackgroundColor: "#2563EB",
        pointHoverBorderColor: "#FFFFFF",
        pointHoverBorderWidth: 3,
      },
    ],
  };
  // console.log(JSON.stringify(domain_composition_data,null,2))
  // console.log(JSON.stringify(v1inv, null, 2))

  const domain_composition_options = {
    responsive: true,
    maintainAspectRatio: false,
    animation: {
      duration: 2000,
      easing: "easeInOutQuart",
      delay: (context) => context.dataIndex * 200,
    },
    interaction: {
      intersect: false,
      mode: "index",
    },
    labels: {
      display: true,
    },
    scales: {
      x: {
        title: {
          display: true,
          text: "Startup Domain",
          color: "#374151",
          font: {
            family: "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI'",
            size: 13,
            weight: 600,
          },
          padding: {
            top: 15,
            bottom: 10,
          },
        },
        grid: {
          display: false,
        },
        ticks: {
          color: "#6B7280",
          font: {
            family: "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI'",
            size: 11,
            weight: 500,
          },
          maxRotation: 45,
          minRotation: 45,
        },
      },
      y: {
        beginAtZero: true,
        title: {
          display: true,
          text: "Current Value",
          color: "#374151",
          font: {
            family: "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI'",
            size: 13,
            weight: 600,
          },
          padding: {
            top: 10,
            bottom: 15,
          },
        },
        grid: {
          color: "rgba(107, 114, 128, 0.1)",
          drawBorder: false,
          lineWidth: 1,
        },
        ticks: {
          color: "#6B7280",
          font: {
            family: "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI'",
            size: 11,
            weight: 500,
          },
          callback: function (value, index, ticks) {
            return `₹${value}L`;
          },
        },
      },
    },
    layout: {
      padding: {
        top: 30,
        bottom: 60,
        left: 20,
        right: 20,
      },
    },

    plugins: {
      tooltip: {
        enabled: true,
        backgroundColor: "rgba(255, 255, 255, 0.95)",
        bodyColor: "#1F2937",
        titleColor: "#374151",
        borderColor: "rgba(226, 232, 240, 0.8)",
        borderWidth: 1,
        cornerRadius: 12,
        displayColors: true,
        titleFont: {
          family: "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI'",
          size: 13,
          weight: 600,
        },
        bodyFont: {
          family: "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI'",
          size: 12,
          weight: 500,
        },
        padding: 16,
        callbacks: {
          label: function (context) {
            var value = context.dataset.data[context.dataIndex];
            var result = Number(value).toFixed(2);
            return `Current Value: ₹${result}L`;
          },
        },
      },
      legend: {
        display: false,
      },
      datalabels: {
        display: false,
      },
    },
  };
  //______________________________________________________________

  // // re-render for pie
  // const [chartData, setChartData] = useState(funds_composition_data);
  // const chartRef = useRef(null);

  // useEffect(() => {
  //   const resizeHandler = () => {
  //     const chartInstance = chartRef.current.chartInstance;
  //     if (chartInstance) {
  //       // Update the chart data as needed
  //       const newChartData = { ...funds_composition_data };
  //       setChartData(newChartData);
  //       chartInstance.update();
  //     }
  //   };

  //   window.addEventListener("resize", resizeHandler);

  //   // Clean up the event listener on component unmount
  //   return () => {
  //     window.removeEventListener("resize", resizeHandler);
  //   };
  // }, [funds_composition_data, v1inv]);

  return (
    <div
      style={{
        display: "flex",
        minHeight: "100vh",
        backgroundColor: "#F8FAFC",
        width: "100%",
        overflowX: "hidden",
      }}
    >
      <Helmet>
        <title>Finvolve - Investor Dashboard</title>
        <link rel="icon" type="image/png" href={favicon} sizes="16x16" />
      </Helmet>

      {/* Main Content */}
      <Box
        sx={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          width: "100%",
          maxWidth: "100%",
          minWidth: 0,
          overflowX: "hidden",
        }}
      >
        {/* Mobile Filter Dialog */}
        <Dialog
          disableEscapeKeyDown
          open={open}
          onClose={handleClose}
          fullWidth
          maxWidth="sm"
          PaperProps={{
            sx: {
              borderRadius: 3,
              boxShadow:
                "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
              maxHeight: "90vh",
            },
          }}
        >
          <DialogTitle
            sx={{
              backgroundColor: "#FFFFFF",
              borderBottom: "1px solid #E2E8F0",
              fontWeight: 600,
              fontSize: "1.25rem",
              color: "#1E293B",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "20px 24px",
            }}
          >
            Filter Selection Menu
            <Button
              onClick={handleClose}
              sx={{
                minWidth: "32px",
                width: "32px",
                height: "32px",
                padding: 0,
                borderRadius: "50%",
                backgroundColor: "transparent",
                color: "#64748B",
                "&:hover": {
                  backgroundColor: "#F1F5F9",
                  color: "#1E293B",
                },
              }}
            >
              <CloseIcon sx={{ fontSize: 20 }} />
            </Button>
          </DialogTitle>
          <DialogContent
            sx={{
              width: "100%",
              minHeight: 280,
              backgroundColor: "#FFFFFF",
              padding: "20px 24px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Box
              component="form"
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: 1.5,
                width: "100%",
                maxWidth: "300px",
                alignItems: "center",
              }}
            >
              <FormControl fullWidth size="small" sx={{ textAlign: "center" }}>
                <InputLabel
                  id="mobile-funds-filter-label"
                  sx={{
                    color: "#64748B",
                    fontWeight: 500,
                    fontSize: "14px",
                  }}
                >
                  Funds
                </InputLabel>
                <Select
                  labelId="mobile-funds-filter-label"
                  id="mobile-funds-filter"
                  multiple
                  value={cfundsName}
                  onChange={handleChangecfunds}
                  input={
                    <OutlinedInput label="Funds" sx={{ fontSize: "14px" }} />
                  }
                  renderValue={(selected) => selected.join(", ")}
                  MenuProps={MenuProps}
                  sx={{
                    height: "40px",
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "6px",
                      backgroundColor: "#FAFBFC",
                    },
                  }}
                >
                  {checks_funds.map((name) => (
                    <MenuItem key={name} value={name} sx={{ fontSize: 14 }}>
                      <Checkbox
                        checked={cfundsName.indexOf(name) > -1}
                        size="small"
                      />
                      <ListItemText primary={name} />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              <FormControl fullWidth size="small" sx={{ textAlign: "center" }}>
                <InputLabel
                  id="mobile-startup-filter-label"
                  sx={{
                    color: "#64748B",
                    fontWeight: 500,
                    fontSize: "14px",
                  }}
                >
                  Startup
                </InputLabel>
                <Select
                  labelId="mobile-startup-filter-label"
                  id="mobile-startup-filter"
                  multiple
                  value={cstartupName}
                  onChange={handleChangecstartup}
                  input={
                    <OutlinedInput label="Startup" sx={{ fontSize: "14px" }} />
                  }
                  renderValue={(selected) => selected.join(", ")}
                  MenuProps={MenuProps}
                  sx={{
                    height: "40px",
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "6px",
                      backgroundColor: "#FAFBFC",
                    },
                  }}
                >
                  {checks_startup.map((name) => (
                    <MenuItem key={name} value={name} sx={{ fontSize: 14 }}>
                      <Checkbox
                        checked={cstartupName.indexOf(name) > -1}
                        size="small"
                      />
                      <ListItemText primary={name} />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              <FormControl fullWidth size="small" sx={{ textAlign: "center" }}>
                <InputLabel
                  id="mobile-domain-filter-label"
                  sx={{
                    color: "#64748B",
                    fontWeight: 500,
                    fontSize: "14px",
                  }}
                >
                  Domain
                </InputLabel>
                <Select
                  labelId="mobile-domain-filter-label"
                  id="mobile-domain-filter"
                  multiple
                  value={cdomainName}
                  onChange={handleChangecdomain}
                  input={
                    <OutlinedInput label="Domain" sx={{ fontSize: "14px" }} />
                  }
                  renderValue={(selected) => selected.join(", ")}
                  MenuProps={MenuProps}
                  sx={{
                    height: "40px",
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "6px",
                      backgroundColor: "#FAFBFC",
                    },
                  }}
                >
                  {checks_domain.map((name) => (
                    <MenuItem key={name} value={name} sx={{ fontSize: 14 }}>
                      <Checkbox
                        checked={cdomainName.indexOf(name) > -1}
                        size="small"
                      />
                      <ListItemText primary={name} />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
          </DialogContent>
          <DialogActions
            sx={{
              backgroundColor: "#FFFFFF",
              borderTop: "1px solid #E2E8F0",
              padding: "16px 20px",
              display: "flex",
              justifyContent: "center",
              gap: 2,
            }}
          >
            <Button
              onClick={handleClearFilters}
              variant="outlined"
              sx={{
                color: "#6B7280",
                borderColor: "#D1D5DB",
                textTransform: "none",
                fontWeight: 500,
                padding: "10px 20px",
                borderRadius: "8px",
                fontSize: 14,
                minWidth: 120,
                "&:hover": {
                  backgroundColor: "#F9FAFB",
                  borderColor: "#9CA3AF",
                },
              }}
            >
              Clear Filters
            </Button>
            <Button
              onClick={handleClose}
              sx={{
                backgroundColor: "#3B82F6",
                color: "white",
                fontWeight: 600,
                padding: "10px 24px",
                borderRadius: "8px",
                textTransform: "none",
                fontSize: 14,
                minWidth: 120,
                "&:hover": {
                  backgroundColor: "#2563EB",
                },
              }}
            >
              Apply Filters
            </Button>
          </DialogActions>
        </Dialog>

        {/* Header */}
        <Box
          sx={{
            backgroundColor: "#FFFFFF",
            borderBottom: "1px solid #E2E8F0",
            boxShadow: "0 1px 3px 0 rgba(0, 0, 0, 0.1)",
            position: "sticky",
            top: 0,
            zIndex: 100,
            width: "100%",
            overflowX: "hidden",
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              px: { xs: 2, sm: 3, lg: 4 },
              py: { xs: 0.75, sm: 1 },
              flexWrap: { xs: "wrap", sm: "nowrap" },
              gap: { xs: 1, sm: 2 },
              width: "100%",
              maxWidth: "100%",
              minWidth: 0,
            }}
          >
            <Box
              component="img"
              src={iconforfvlogo}
              alt="Finvolve Logo"
              sx={{
                width: { xs: "90px", sm: "110px", lg: "130px" },
                height: { xs: "32px", sm: "40px", lg: "48px" },
                objectFit: "contain",
                filter: "drop-shadow(0 1px 2px rgba(0, 0, 0, 0.1))",
                flexShrink: 0,
              }}
            />

            <Box
              sx={{
                display: "flex",
                gap: { xs: 1, sm: 2 },
                alignItems: "center",
                flexWrap: { xs: "wrap", sm: "nowrap" },
                flexShrink: 1,
                minWidth: 0,
              }}
            >
              <Button
                variant="outlined"
                href="/investor-password-reset"
                sx={{
                  color: "#3B82F6",
                  borderColor: "#E2E8F0",
                  textTransform: "none",
                  fontWeight: 500,
                  fontSize: { xs: 12, sm: 13 },
                  padding: { xs: "6px 12px", sm: "8px 16px" },
                  borderRadius: "8px",
                  minWidth: { xs: "auto", sm: "110px" },
                  height: { xs: "32px", sm: "36px" },
                  flexShrink: 1,
                  "&:hover": {
                    backgroundColor: "#F8FAFC",
                    borderColor: "#3B82F6",
                  },
                }}
              >
                <Box
                  component="span"
                  sx={{ display: { xs: "none", sm: "inline" } }}
                >
                  Reset Password
                </Box>
                <Box
                  component="span"
                  sx={{ display: { xs: "inline", sm: "none" } }}
                >
                  Reset
                </Box>
              </Button>
              <Button
                variant="contained"
                onClick={handleAccreditationClick}
                sx={{
                  backgroundColor: "#10B981",
                  color: "white",
                  textTransform: "none",
                  fontWeight: 500,
                  fontSize: { xs: 12, sm: 13 },
                  padding: { xs: "6px 12px", sm: "8px 16px" },
                  borderRadius: "8px",
                  minWidth: { xs: "auto", sm: "140px" },
                  height: { xs: "32px", sm: "36px" },
                  flexShrink: 1,
                  boxShadow: "none",
                  display: "flex",
                  alignItems: "center",
                  gap: 0.5,
                  "&:hover": {
                    backgroundColor: "#059669",
                    boxShadow: "0 2px 4px rgba(16, 185, 129, 0.2)",
                  },
                }}
              >
                <Box
                  component="span"
                  sx={{ display: { xs: "none", sm: "inline" } }}
                >
                  Apply For Accreditation
                </Box>
                <Box
                  component="span"
                  sx={{ display: { xs: "inline", sm: "none" } }}
                >
                  Accreditation
                </Box>
                <OpenInNewIcon
                  sx={{
                    fontSize: { xs: 14, sm: 16 },
                    ml: { xs: 0.5, sm: 0.5 },
                  }}
                />
              </Button>
              <Button
                variant="contained"
                href="/investor-login"
                onClick={handleLinkClickfv}
                sx={{
                  backgroundColor: "#EF4444",
                  color: "white",
                  textTransform: "none",
                  fontWeight: 500,
                  fontSize: { xs: 12, sm: 13 },
                  padding: { xs: "6px 12px", sm: "8px 16px" },
                  borderRadius: "8px",
                  minWidth: { xs: "auto", sm: "90px" },
                  height: { xs: "32px", sm: "36px" },
                  flexShrink: 1,
                  boxShadow: "none",
                  "&:hover": {
                    backgroundColor: "#DC2626",
                    boxShadow: "0 2px 4px rgba(239, 68, 68, 0.2)",
                  },
                }}
              >
                Sign Out
              </Button>
            </Box>
          </Box>
        </Box>

        {/* Main Content Area */}
        <Box sx={{ flex: 1, p: { xs: 2, lg: 3 } }}>
          {/* Welcome Message and Filter Button Row */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 2,
              flexWrap: { xs: "wrap", sm: "nowrap" },
              gap: { xs: 1, sm: 0 },
            }}
          >
            <Typography
              fontFamily="Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI'"
              variant="h4"
              fontWeight={500}
              color="#000000"
              sx={{
                fontSize: { xs: "1.5rem", sm: "2rem", lg: "2.125rem" },
                lineHeight: { xs: 1.2, sm: 1.3 },
                wordBreak: "break-word",
              }}
            >
              Welcome back, {iname}
            </Typography>
            <Button
              onClick={handleClickOpen}
              sx={{
                backgroundColor: "#3B82F6",
                color: "white",
                borderRadius: "50%",
                minWidth: { xs: "40px", sm: "48px" },
                width: { xs: "40px", sm: "48px" },
                height: { xs: "40px", sm: "48px" },
                padding: 0,
                flexShrink: 0,
                "&:hover": {
                  backgroundColor: "#2563EB",
                  transform: "scale(1.05)",
                  transition: "all 0.2s ease-in-out",
                },
              }}
            >
              <FilterListIcon sx={{ fontSize: { xs: 20, sm: 24 } }} />
            </Button>
          </Box>

          {/* Wealth Manager Display */}
          {wealth_manager && wealth_manager.length > 0 && (
            <Box
              sx={{
                mb: 2,
                display: "flex",
                alignItems: "center",
                gap: 1,
                flexWrap: "wrap",
              }}
            >
              <PersonIcon
                sx={{
                  color: "#6B7280",
                  fontSize: { xs: 18, sm: 20 },
                }}
              />
              <Typography
                fontFamily="Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI'"
                fontSize={{ xs: 14, sm: 16 }}
                fontWeight={400}
                color="#6B7280"
                sx={{
                  letterSpacing: "0.01em",
                  wordBreak: "break-word",
                }}
              >
                Wealth Manager:{" "}
                <Box
                  component="span"
                  sx={{ fontWeight: 600, color: "#1F2937" }}
                >
                  {wealth_manager.length === 1
                    ? wealth_manager[0]
                    : wealth_manager.join(", ")}
                </Box>
              </Typography>
            </Box>
          )}

          <Grid
            container
            sx={{
              backgroundColor: "#F8FAFC",
              border: { xs: "none", lg: "none" },
              minHeight: "100vh",
            }}
          >
            <Grid
              container
              spacing={2}
              sx={{ backgroundColor: "#F8FAFC" }}
              pt={2}
              mb={2}
            >
              {/* 1. Domains Covered Card */}
              <Grid item xs={12} sm={6} md={4} lg={2.4} xl={2.4}>
                <Paper
                  elevation={0}
                  sx={{
                    background:
                      "linear-gradient(135deg, #FFFFFF 0%, #F8FAFC 100%)",
                    borderRadius: "16px",
                    padding: "20px",
                    border: "1px solid #E2E8F0",
                    boxShadow:
                      "0 4px 20px rgba(0, 0, 0, 0.08), 0 1px 3px rgba(0, 0, 0, 0.1)",
                    position: "relative",
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    gap: 3,
                    width: "100%",
                    minHeight: "90px",
                    height: "90px",
                  }}
                >
                  <Box
                    sx={{
                      backgroundColor: "#F59E0B",
                      borderRadius: 2,
                      padding: 1.5,
                      width: { xs: 32, sm: 40 },
                      height: { xs: 32, sm: 40 },
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexShrink: 0,
                    }}
                  >
                    <CategoryIcon
                      sx={{ color: "white", fontSize: { xs: 16, sm: 20 } }}
                    />
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-start",
                      minWidth: 0,
                      flex: 1,
                    }}
                  >
                    <Typography
                      fontFamily="Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI'"
                      fontSize={{ xs: 12, sm: 14 }}
                      color="#4B5563"
                      fontWeight={600}
                      sx={{
                        mb: 0.5,
                        letterSpacing: "0.025em",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        maxWidth: "100%",
                      }}
                    >
                      Domains Covered
                    </Typography>
                    <Typography
                      fontFamily="Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI'"
                      fontSize={{ xs: 16, sm: 18, lg: 20 }}
                      fontWeight={700}
                      color="#1F2937"
                      sx={{
                        letterSpacing: "0.025em",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      {domains_covered}
                    </Typography>
                  </Box>
                </Paper>
              </Grid>

              {/* 2. Startups Covered Card */}
              <Grid item xs={12} sm={6} md={4} lg={2.4} xl={2.4}>
                <Paper
                  elevation={0}
                  sx={{
                    background:
                      "linear-gradient(135deg, #FFFFFF 0%, #F8FAFC 100%)",
                    borderRadius: "16px",
                    padding: "20px",
                    border: "1px solid #E2E8F0",
                    boxShadow:
                      "0 4px 20px rgba(0, 0, 0, 0.08), 0 1px 3px rgba(0, 0, 0, 0.1)",
                    position: "relative",
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    gap: 3,
                    width: "100%",
                    minHeight: "90px",
                    height: "90px",
                  }}
                >
                  <Box
                    sx={{
                      backgroundColor: "#8B5CF6",
                      borderRadius: 2,
                      padding: 1.5,
                      width: { xs: 32, sm: 40 },
                      height: { xs: 32, sm: 40 },
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexShrink: 0,
                    }}
                  >
                    <BusinessIcon
                      sx={{ color: "white", fontSize: { xs: 16, sm: 20 } }}
                    />
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-start",
                      minWidth: 0,
                      flex: 1,
                    }}
                  >
                    <Typography
                      fontFamily="Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI'"
                      fontSize={{ xs: 12, sm: 14 }}
                      color="#4B5563"
                      fontWeight={600}
                      sx={{
                        mb: 0.5,
                        letterSpacing: "0.025em",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        maxWidth: "100%",
                      }}
                    >
                      Startups Covered
                    </Typography>
                    <Typography
                      fontFamily="Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI'"
                      fontSize={{ xs: 16, sm: 18, lg: 20 }}
                      fontWeight={700}
                      color="#1F2937"
                      sx={{
                        letterSpacing: "0.025em",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      {startups_covered}
                    </Typography>
                  </Box>
                </Paper>
              </Grid>

              {/* 3. Total Investments Card */}
              <Grid item xs={12} sm={6} md={4} lg={2.4} xl={2.4}>
                <Paper
                  elevation={0}
                  sx={{
                    background:
                      "linear-gradient(135deg, #FFFFFF 0%, #F8FAFC 100%)",
                    borderRadius: "16px",
                    padding: "20px",
                    border: "1px solid #E2E8F0",
                    boxShadow:
                      "0 4px 20px rgba(0, 0, 0, 0.08), 0 1px 3px rgba(0, 0, 0, 0.1)",
                    position: "relative",
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    gap: 3,
                    width: "100%",
                    minHeight: "90px",
                    height: "90px",
                  }}
                >
                  <Box
                    sx={{
                      backgroundColor: "#3B82F6",
                      borderRadius: 2,
                      padding: 1.5,
                      width: { xs: 32, sm: 40 },
                      height: { xs: 32, sm: 40 },
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexShrink: 0,
                    }}
                  >
                    <AttachMoneyIcon
                      sx={{ color: "white", fontSize: { xs: 16, sm: 20 } }}
                    />
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-start",
                      minWidth: 0,
                      flex: 1,
                    }}
                  >
                    <Typography
                      fontFamily="Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI'"
                      fontSize={{ xs: 12, sm: 14 }}
                      color="#4B5563"
                      fontWeight={600}
                      sx={{
                        mb: 0.5,
                        letterSpacing: "0.025em",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        maxWidth: "100%",
                      }}
                    >
                      Total Investments
                    </Typography>
                    <Typography
                      fontFamily="Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI'"
                      fontSize={{ xs: 16, sm: 18, lg: 20 }}
                      fontWeight={700}
                      color="#1F2937"
                      sx={{
                        letterSpacing: "0.025em",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      {formatter.format(total_inv)}L
                    </Typography>
                  </Box>
                </Paper>
              </Grid>

              {/* 4. Current Value Card */}
              <Grid item xs={12} sm={6} md={4} lg={2.4} xl={2.4}>
                <Paper
                  elevation={0}
                  sx={{
                    background:
                      "linear-gradient(135deg, #FFFFFF 0%, #F8FAFC 100%)",
                    borderRadius: "16px",
                    padding: "20px",
                    border: "1px solid #E2E8F0",
                    boxShadow:
                      "0 4px 20px rgba(0, 0, 0, 0.08), 0 1px 3px rgba(0, 0, 0, 0.1)",
                    position: "relative",
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    gap: 3,
                    width: "100%",
                    minHeight: "90px",
                    height: "90px",
                  }}
                >
                  <Box
                    sx={{
                      backgroundColor: "#10B981",
                      borderRadius: 2,
                      padding: 1.5,
                      width: { xs: 32, sm: 40 },
                      height: { xs: 32, sm: 40 },
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexShrink: 0,
                    }}
                  >
                    <TrendingUpIcon
                      sx={{ color: "white", fontSize: { xs: 16, sm: 20 } }}
                    />
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-start",
                      minWidth: 0,
                      flex: 1,
                    }}
                  >
                    <Typography
                      fontFamily="Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI'"
                      fontSize={{ xs: 12, sm: 14 }}
                      color="#4B5563"
                      fontWeight={600}
                      sx={{
                        mb: 0.5,
                        letterSpacing: "0.025em",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        maxWidth: "100%",
                      }}
                    >
                      Current Value
                    </Typography>
                    <Typography
                      fontFamily="Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI'"
                      fontSize={{ xs: 16, sm: 18, lg: 20 }}
                      fontWeight={700}
                      color="#1F2937"
                      sx={{
                        letterSpacing: "0.025em",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      {formatter.format(current_value)}L
                    </Typography>
                  </Box>
                </Paper>
              </Grid>

              {/* 5. Unrealized P&L Card */}
              <Grid item xs={12} sm={6} md={4} lg={2.4} xl={2.4}>
                <Paper
                  elevation={0}
                  sx={{
                    background:
                      "linear-gradient(135deg, #FFFFFF 0%, #F8FAFC 100%)",
                    borderRadius: "16px",
                    padding: "20px",
                    border: "1px solid #E2E8F0",
                    boxShadow:
                      "0 4px 20px rgba(0, 0, 0, 0.08), 0 1px 3px rgba(0, 0, 0, 0.1)",
                    position: "relative",
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    gap: 3,
                    width: "100%",
                    minHeight: "90px",
                    height: "90px",
                  }}
                >
                  <Box
                    sx={{
                      backgroundColor: pnl >= 0 ? "#10B981" : "#EF4444",
                      borderRadius: 2,
                      padding: 1.5,
                      width: { xs: 32, sm: 40 },
                      height: { xs: 32, sm: 40 },
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexShrink: 0,
                    }}
                  >
                    <AccountBalanceWalletIcon
                      sx={{ color: "white", fontSize: { xs: 16, sm: 20 } }}
                    />
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-start",
                      minWidth: 0,
                      flex: 1,
                    }}
                  >
                    <Typography
                      fontFamily="Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI'"
                      fontSize={{ xs: 12, sm: 14 }}
                      color="#4B5563"
                      fontWeight={600}
                      sx={{
                        mb: 0.5,
                        letterSpacing: "0.025em",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        maxWidth: "100%",
                      }}
                    >
                      Unrealized P&L
                    </Typography>
                    <Typography
                      fontFamily="Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI'"
                      fontSize={{ xs: 16, sm: 18, lg: 20 }}
                      fontWeight={700}
                      color="#1F2937"
                      sx={{
                        letterSpacing: "0.025em",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      {formatter.format(pnl)} L
                    </Typography>
                  </Box>
                </Paper>
              </Grid>

              {/* 6. Last Invested on Card */}
              <Grid item xs={12} sm={6} md={4} lg={2.4} xl={2.4}>
                <Paper
                  elevation={0}
                  sx={{
                    background:
                      "linear-gradient(135deg, #FFFFFF 0%, #F8FAFC 100%)",
                    borderRadius: "16px",
                    padding: "20px",
                    border: "1px solid #E2E8F0",
                    boxShadow:
                      "0 4px 20px rgba(0, 0, 0, 0.08), 0 1px 3px rgba(0, 0, 0, 0.1)",
                    position: "relative",
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    gap: 3,
                    width: "100%",
                    minHeight: "90px",
                    height: "90px",
                  }}
                >
                  <Box
                    sx={{
                      backgroundColor: "#06B6D4",
                      borderRadius: 2,
                      padding: 1.5,
                      width: { xs: 32, sm: 40 },
                      height: { xs: 32, sm: 40 },
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexShrink: 0,
                    }}
                  >
                    <CalendarTodayIcon
                      sx={{ color: "white", fontSize: { xs: 16, sm: 20 } }}
                    />
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-start",
                      minWidth: 0,
                      flex: 1,
                    }}
                  >
                    <Typography
                      fontFamily="Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI'"
                      fontSize={{ xs: 12, sm: 14 }}
                      color="#4B5563"
                      fontWeight={600}
                      sx={{
                        mb: 0.5,
                        letterSpacing: "0.025em",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        maxWidth: "100%",
                      }}
                    >
                      Last Invested on
                    </Typography>
                    <Typography
                      fontFamily="Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI'"
                      fontSize={{ xs: 16, sm: 18, lg: 20 }}
                      fontWeight={700}
                      color="#1F2937"
                      sx={{
                        letterSpacing: "0.025em",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      {latest_date}
                    </Typography>
                  </Box>
                </Paper>
              </Grid>
            </Grid>

            <Grid
              container
              spacing={2}
              sx={{ backgroundColor: "#F8FAFC" }}
              pt={2}
              mb={2}
              //sx={{ border: "solid" }}
            >
              {/* <Grid item p={{xs:3,lg:0}} pt={{xs:2,lg:1}} pl={{xs:3,lg:2}} xs={12} lg={4}>
          <Paper
            elevation={2}
            sx={{
              padding: "10px",
              maxWidth: "100%",
              height: "320px",
              borderRadius: "10px",
              border: "none",
            }}>
            <Typography fontFamily={"Arial"} fontSize={18} fontWeight={500} color={"Black"} height={"6%"}>
              Funds Composition
            </Typography>
            <Doughnut data={funds_composition_data} plugins={[ChartPieChartOutlabels]} options={funds_composition_options} />            
          </Paper>
        </Grid> */}
              <Grid item xs={12}>
                <Paper
                  elevation={0}
                  sx={{
                    padding: "20px",
                    maxWidth: "100%",
                    height: { xs: "300px", sm: "350px", lg: "380px" },
                    borderRadius: "20px",
                    border: "1px solid rgba(0, 0, 0, 0.08)",
                    backgroundColor: "#FFFFFF",
                  }}
                >
                  <Typography
                    fontFamily={
                      "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI'"
                    }
                    fontSize={22}
                    fontWeight={500}
                    color={"#0F172A"}
                    mb={2}
                    sx={{
                      letterSpacing: "-0.025em",
                      textShadow: "0 1px 2px rgba(0, 0, 0, 0.05)",
                      background:
                        "linear-gradient(135deg, #0F172A 0%, #1E293B 100%)",
                      backgroundClip: "text",
                      WebkitBackgroundClip: "text",
                      WebkitTextFillColor: "transparent",
                    }}
                  >
                    Startups Composition
                  </Typography>
                  <Box
                    sx={{
                      width: "100%",
                      height: "100%",
                      overflow: "hidden",
                      position: "relative",
                    }}
                  >
                    <Line
                      data={startups_composition_data}
                      plugins={[ChartDataLabels]}
                      options={startups_composition_options}
                    />
                  </Box>
                </Paper>
              </Grid>
              <Grid item xs={12}>
                <Paper
                  elevation={0}
                  sx={{
                    padding: "20px",
                    maxWidth: "100%",
                    height: { xs: "300px", sm: "350px", lg: "380px" },
                    borderRadius: "20px",
                    border: "1px solid rgba(0, 0, 0, 0.08)",
                    backgroundColor: "#FFFFFF",
                  }}
                >
                  <Typography
                    fontFamily={
                      "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI'"
                    }
                    fontSize={22}
                    fontWeight={500}
                    color={"#0F172A"}
                    mb={2}
                    sx={{
                      letterSpacing: "-0.025em",
                      textShadow: "0 1px 2px rgba(0, 0, 0, 0.05)",
                      background:
                        "linear-gradient(135deg, #0F172A 0%, #1E293B 100%)",
                      backgroundClip: "text",
                      WebkitBackgroundClip: "text",
                      WebkitTextFillColor: "transparent",
                    }}
                  >
                    Domain Composition
                  </Typography>
                  <Box
                    sx={{
                      width: "100%",
                      height: "100%",
                      overflow: "hidden",
                      position: "relative",
                    }}
                  >
                    <Line
                      data={domain_composition_data}
                      plugins={[ChartDataLabels]}
                      options={domain_composition_options}
                    />
                  </Box>
                </Paper>
              </Grid>
            </Grid>

            <Grid
              pt={2}
              mb={2}
              container
              spacing={2}
              sx={{ backgroundColor: "#F8FAFC" }}
              //sx={{ border: "solid" }}
            >
              <Grid item xs={12} lg={12}>
                <Paper
                  sx={{
                    padding: "20px",
                    maxWidth: "100%",
                    minHeight: "360px",
                    borderRadius: "20px",
                    border: "1px solid rgba(0, 0, 0, 0.08)",
                    backgroundColor: "#FFFFFF",
                  }}
                  elevation={0}
                >
                  <Typography
                    fontFamily={
                      "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI'"
                    }
                    fontSize={22}
                    fontWeight={500}
                    color={"#0F172A"}
                    mb={2}
                    sx={{
                      letterSpacing: "-0.025em",
                      textShadow: "0 1px 2px rgba(0, 0, 0, 0.05)",
                      background:
                        "linear-gradient(135deg, #0F172A 0%, #1E293B 100%)",
                      backgroundClip: "text",
                      WebkitBackgroundClip: "text",
                      WebkitTextFillColor: "transparent",
                    }}
                  >
                    Transaction Summary
                  </Typography>
                  <TableContainer
                    m={0}
                    p={0}
                    sx={{
                      minHeight: "500px",
                      maxHeight: "500px",
                      width: "100%",
                      overflowX: "auto",
                      overflowY: "auto",
                      border: "1px solid #E5E7EB",
                      borderRadius: "8px",
                    }}
                  >
                    <Table
                      aria-label="simple table"
                      size="small"
                      stickyHeader
                      sx={{
                        tableLayout: "fixed",
                        width: "100%",
                        minWidth: "1400px",
                      }}
                    >
                      <TableHead
                        sx={{
                          "& .MuiTableCell-root": {
                            backgroundColor: "#F8FAFC",
                            fontWeight: 600,
                            borderBottom: "1px solid #E5E7EB",
                            padding: "16px 12px",
                            fontSize: "14px",
                            color: "#111827",
                            whiteSpace: "nowrap",
                            minWidth: "120px",
                          },
                        }}
                      >
                        <TableRow>
                          <TableCell
                            sx={{
                              fontFamily:
                                "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI'",
                              fontSize: "14",
                              color: "#111827",
                              fontWeight: 600,
                              textTransform: "none",
                              letterSpacing: "0",
                              whiteSpace: "nowrap",
                              width: "120px",
                            }}
                            align="left"
                          >
                            Issue Date
                          </TableCell>
                          <TableCell
                            sx={{
                              fontFamily:
                                "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI'",
                              fontSize: "14",
                              color: "#111827",
                              fontWeight: 600,
                              textTransform: "none",
                              letterSpacing: "0",
                              width: "140px",
                              maxWidth: "140px",
                            }}
                            align="center"
                          >
                            Fund
                          </TableCell>
                          <TableCell
                            sx={{
                              fontFamily:
                                "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI'",
                              fontSize: "14",
                              color: "#111827",
                              fontWeight: 600,
                              textTransform: "none",
                              letterSpacing: "0",
                              whiteSpace: "nowrap",
                              width: "160px",
                            }}
                            align="center"
                          >
                            Invested Startup
                          </TableCell>
                          <TableCell
                            sx={{
                              fontFamily:
                                "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI'",
                              fontSize: "14",
                              color: "#111827",
                              fontWeight: 600,
                              textTransform: "none",
                              letterSpacing: "0",
                              whiteSpace: "nowrap",
                              width: "160px",
                            }}
                            align="center"
                          >
                            Domain
                          </TableCell>
                          <TableCell
                            sx={{
                              fontFamily:
                                "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI'",
                              fontSize: "14",
                              color: "#111827",
                              fontWeight: 600,
                              textTransform: "none",
                              letterSpacing: "0",
                              whiteSpace: "nowrap",
                              width: "100px",
                            }}
                            align="center"
                          >
                            Round
                          </TableCell>
                          <TableCell
                            sx={{
                              fontFamily:
                                "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI'",
                              fontSize: "14",
                              color: "#111827",
                              fontWeight: 600,
                              textTransform: "none",
                              letterSpacing: "0",
                              whiteSpace: "nowrap",
                              width: "100px",
                            }}
                            align="center"
                          >
                            Units
                          </TableCell>
                          <TableCell
                            sx={{
                              fontFamily:
                                "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI'",
                              fontSize: "14",
                              color: "#111827",
                              fontWeight: 600,
                              textTransform: "none",
                              letterSpacing: "0",
                              whiteSpace: "nowrap",
                              width: "120px",
                            }}
                            align="center"
                          >
                            Avg. NAV
                          </TableCell>
                          <TableCell
                            sx={{
                              fontFamily:
                                "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI'",
                              fontSize: "14",
                              color: "#111827",
                              fontWeight: 600,
                              textTransform: "none",
                              letterSpacing: "0",
                              whiteSpace: "nowrap",
                              width: "130px",
                            }}
                            align="center"
                          >
                            Current NAV
                          </TableCell>
                          <TableCell
                            sx={{
                              fontFamily:
                                "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI'",
                              fontSize: "14",
                              color: "#111827",
                              fontWeight: 600,
                              textTransform: "none",
                              letterSpacing: "0",
                              whiteSpace: "nowrap",
                              width: "140px",
                            }}
                            align="center"
                          >
                            Amount Invested
                          </TableCell>
                          <TableCell
                            sx={{
                              fontFamily:
                                "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI'",
                              fontSize: "14",
                              color: "#111827",
                              fontWeight: 600,
                              textTransform: "none",
                              letterSpacing: "0",
                              whiteSpace: "nowrap",
                              width: "130px",
                            }}
                            align="center"
                          >
                            Current Value
                          </TableCell>
                          <TableCell
                            sx={{
                              fontFamily:
                                "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI'",
                              fontSize: "14",
                              color: "#111827",
                              fontWeight: 600,
                              textTransform: "none",
                              letterSpacing: "0",
                              whiteSpace: "nowrap",
                              width: "100px",
                            }}
                            align="center"
                          >
                            P&L
                          </TableCell>
                          <TableCell
                            sx={{
                              fontFamily:
                                "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI'",
                              fontSize: "14",
                              color: "#111827",
                              fontWeight: 600,
                              textTransform: "none",
                              letterSpacing: "0",
                              whiteSpace: "nowrap",
                              width: "100px",
                            }}
                            align="center"
                          >
                            P&L%
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {tdata.map((tdata, index) => (
                          <TableRow
                            key={index}
                            sx={{
                              "&:last-child td, &:last-child th": { border: 0 },
                              borderBottom: "1px solid #E5E7EB",
                              backgroundColor: "#FFFFFF",
                              transition: "all 0.2s ease-in-out",
                              "&:hover": {
                                backgroundColor: "#F8FAFC",
                                cursor: "pointer",
                                "& td": {
                                  backgroundColor: "transparent",
                                },
                              },
                            }}
                          >
                            <TableCell
                              sx={{
                                fontFamily:
                                  "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI'",
                                fontSize: "14",
                                overflow: "hidden",
                                whiteSpace: "nowrap",
                                fontWeight: 400,
                                color: "#111827",
                                padding: "12px",
                              }}
                              component="th"
                              scope="row"
                            >
                              {tdata.issuedate2}
                            </TableCell>
                            <TableCell
                              sx={{
                                fontFamily:
                                  "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI'",
                                fontSize: "14",
                                overflow: "hidden",
                                whiteSpace: "normal",
                                wordBreak: "break-word",
                                lineHeight: 1.4,
                                fontWeight: 400,
                                color: "#111827",
                                padding: "12px 8px",
                                maxWidth: "140px",
                                width: "140px",
                                maxHeight: "60px",
                              }}
                              align="center"
                              title={tdata.fundname}
                            >
                              {tdata.fundname}
                            </TableCell>
                            <TableCell
                              sx={{
                                fontFamily:
                                  "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI'",
                                fontSize: "14",
                                fontWeight: 400,
                                color: "#111827",
                                padding: "12px 8px",
                                wordBreak: "break-word",
                                lineHeight: 1.4,
                              }}
                              align="center"
                            >
                              {tdata.startupname}
                            </TableCell>
                            <TableCell
                              sx={{
                                fontFamily:
                                  "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI'",
                                fontSize: "14",
                                fontWeight: 400,
                                color: "#111827",
                                padding: "12px 8px",
                                wordBreak: "break-word",
                                lineHeight: 1.4,
                              }}
                              align="center"
                            >
                              {tdata.SU_Domain}
                            </TableCell>
                            <TableCell
                              sx={{
                                fontFamily:
                                  "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI'",
                                fontSize: "14",
                                overflow: "hidden",
                                whiteSpace: "nowrap",
                                fontWeight: 400,
                                color: "#111827",
                                padding: "12px",
                              }}
                              align="center"
                            >
                              {tdata.round}
                            </TableCell>
                            <TableCell
                              sx={{
                                fontFamily:
                                  "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI'",
                                fontSize: "14",
                                overflow: "hidden",
                                whiteSpace: "nowrap",
                                fontWeight: 400,
                                color: "#111827",
                                padding: "12px",
                              }}
                              align="center"
                            >
                              {Number(tdata?.units)?.toFixed(2)}
                            </TableCell>
                            <TableCell
                              sx={{
                                fontFamily:
                                  "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI'",
                                fontSize: "14",
                                overflow: "hidden",
                                whiteSpace: "nowrap",
                                fontWeight: 400,
                                color: "#111827",
                                padding: "12px",
                              }}
                              align="center"
                            >
                              ₹{tdata.unitprice}
                            </TableCell>
                            <TableCell
                              sx={{
                                fontFamily:
                                  "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI'",
                                fontSize: "14",
                                overflow: "hidden",
                                whiteSpace: "nowrap",
                                fontWeight: 400,
                                color: "#111827",
                                padding: "12px",
                              }}
                              align="center"
                            >
                              ₹{tdata.Cunitprice}
                            </TableCell>
                            <TableCell
                              sx={{
                                fontFamily:
                                  "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI'",
                                fontSize: "14",
                                overflow: "hidden",
                                whiteSpace: "nowrap",
                                fontWeight: 400,
                                color: "#111827",
                                padding: "12px",
                              }}
                              align="center"
                            >
                              {/* ₹{v1inv.ival_l.toFixed(2)}L */}₹
                              {parseFloat(tdata.ival_l).toFixed(2)}L
                            </TableCell>
                            <TableCell
                              sx={{
                                fontFamily:
                                  "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI'",
                                fontSize: "14",
                                overflow: "hidden",
                                whiteSpace: "nowrap",
                                fontWeight: 400,
                                color: "#111827",
                                padding: "12px",
                              }}
                              align="center"
                            >
                              ₹{parseFloat(tdata.Cval_l).toFixed(2)}L
                            </TableCell>
                            <TableCell
                              sx={{
                                fontFamily:
                                  "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI'",
                                fontSize: "14",
                                overflow: "hidden",
                                whiteSpace: "nowrap",
                                fontWeight: 400,
                                color: "#111827",
                                padding: "12px",
                              }}
                              align="center"
                            >
                              ₹{parseFloat(tdata.pnl).toFixed(2)}L
                            </TableCell>
                            <TableCell
                              sx={{
                                fontFamily:
                                  "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI'",
                                fontSize: "14",
                                overflow: "hidden",
                                whiteSpace: "nowrap",
                                fontWeight: 400,
                                color: "#111827",
                                padding: "12px",
                              }}
                              align="center"
                            >
                              {parseFloat(tdata.pnlp).toFixed(2)}%
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Paper>
              </Grid>
            </Grid>
            <Grid
              container
              sx={{ backgroundColor: "#F8FAFC" }}
              display={"flex"}
              justifyContent="flex-start"
              pt={0}
              mt={2}
              //sx={{ border: "solid" }}
            >
              <Grid item lg={6}>
                <Grid
                  container
                  display={"flex"}
                  justifyContent="flex-start"
                  pt={0}
                  mt={0}
                  //sx={{ border: "solid" }}
                ></Grid>
              </Grid>
              <Grid item lg={6}>
                <Grid
                  container
                  display={"flex"}
                  direction={"row-reverse"}
                  justifyContent="flex-start"
                  pr={1}
                  mt={0}
                  //sx={{ border: "solid" }}
                >
                  {/* <Grid item pl={{xs:0,lg:1}} pt={{xs:3,lg:3}} pr={{xs:0,lg:2}}>
              <img src={logo} alt="IA Logo" style={{ width: 300, height: 35 }} />
            </Grid>             */}
                  <Grid
                    item
                    pl={{ xs: 3, lg: 1 }}
                    pt={{ xs: 0, lg: 5 }}
                    pr={{ lg: 2 }}
                  >
                    <Typography
                      fontFamily="Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI'"
                      fontSize={14}
                      color="#64748B"
                      fontWeight={500}
                    >
                      {`Data as of now: 15-Feb-2026`}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </div>
  );
}
export default Dashh;
